import { downloadBlobFromDom } from '@common/services';
import { QueryReturnValue } from '@reduxjs/toolkit/dist/query';

export async function queryDownloadFile(args: QueryDownloadFileArgs): Promise<QueryReturnValue<void>> {
  const { baseQuery, url, params, defaultFilename, forceDefaultFilename } = args;

  const { data: blob, error, meta } = await baseQuery({
    url,
    params,
    responseHandler: (res) => res.blob(),
  });

  if (error) return { error };

  downloadBlobFromDom(blob, meta, defaultFilename, forceDefaultFilename);

  return { data: undefined };
}

interface QueryDownloadFileArgs {
  baseQuery: any;
  url: string;
  params?: URLSearchParams | Record<string, string>;
  defaultFilename?: string;
  forceDefaultFilename?: boolean;
}